import {
  PATH_NAMES,
  WELDING_APPOINTMENT_IDS,
  STUBS_APPOINTMENT_IDS,
  STAGING_APPOINTMENT_IDS,
  PROD_APPOINTMENT_IDS,
  PIERCING_SERVICE_TITLE,
  WELDING_SERVICE_TITLE,
} from '../constants';
import { store } from '~/store';
import { ENV_VARS, STAGE } from '../../../../config';

const { WELDING_TYPE, PIERCING_TYPE } = PATH_NAMES;
const { REACT_APP_STAGE } = ENV_VARS;

const getPathName = () => document?.location?.href || undefined;

const getObjectKeys = (data) => (data ? Object.keys(data) : ['-1']);

const isDataObject = (data) => typeof data === 'object';

const getStateValue = (param) =>
  store?.getState()?.appointment?.draft?.appointmentType[param] || undefined;

const appointmentId = getStateValue('id');

const isValueIncludedInPath = (val) => {
  const path = getPathName();

  return path?.includes(val.toString());
};

const isAppointmentIdForWelding = () =>
  WELDING_APPOINTMENT_IDS.find((id) => isValueIncludedInPath(id.toString()));

const isWeldingService = () => {
  const isPathNameForWelding = isValueIncludedInPath(WELDING_TYPE);
  const isWeldingAppointmentId = isAppointmentIdForWelding();

  return isPathNameForWelding || isWeldingAppointmentId || appointmentId in WELDING_APPOINTMENT_IDS;
};

const getDataForPiercingService = (piercingData, weldingData) =>
  isWeldingService() ? weldingData : piercingData;

const servicePageTitle =
  getStateValue('name') || getDataForPiercingService(PIERCING_SERVICE_TITLE, WELDING_SERVICE_TITLE);

const piercingServicePagePath = getDataForPiercingService(PIERCING_TYPE, WELDING_TYPE);

const getPiercingAppointmentIds = () => {
  switch (REACT_APP_STAGE) {
    case STAGE.LOCAL:
    case STAGE.DEV:
      return STUBS_APPOINTMENT_IDS;
    case STAGE.TEST:
      return STAGING_APPOINTMENT_IDS;
    default:
      return PROD_APPOINTMENT_IDS;
  }
};

export {
  getDataForPiercingService,
  getPiercingAppointmentIds,
  getObjectKeys,
  isDataObject,
  piercingServicePagePath,
  servicePageTitle,
};
